module.exports = __webpack_public_path__ + "img/syfol_logo.7fd8944a.png";